export const GROUPS = [
  {
    said: "work and time",
    icons: [
      "folder",
      "briefcase",
      "calendar",
      "clock",
      "timer",
      "hourglass",
      "bell",
      "inbox",
      "archive",
      "list-checks",
      "clipboard-list",
      "target",
      "flag",
      "bookmark",
      "tag",
      "pin",
      "milestone",
      "workflow",
    ],
  },
  {
    said: "people",
    icons: ["user", "users", "user-plus", "handshake", "smile", "graduation-cap", "brain", "eye"],
  },
  {
    said: "talking",
    icons: [
      "messages-square",
      "message-circle",
      "mail",
      "send",
      "phone",
      "video",
      "mic",
      "megaphone",
      "at-sign",
      "hash",
      "link",
      "share-2",
    ],
  },
  {
    said: "code and machines",
    icons: [
      "code",
      "terminal",
      "git-branch",
      "git-merge",
      "git-pull-request",
      "git-fork",
      "bug",
      "cpu",
      "database",
      "server",
      "hard-drive",
      "cloud",
      "container",
      "package",
      "boxes",
      "keyboard",
      "monitor",
      "smartphone",
      "laptop",
      "bot",
      "network",
      "key",
    ],
  },
  {
    said: "making",
    icons: [
      "palette",
      "paintbrush",
      "pen-tool",
      "pencil",
      "ruler",
      "scissors",
      "crop",
      "shapes",
      "image",
      "camera",
      "film",
      "wand-sparkles",
      "type",
      "layers",
    ],
  },
  {
    said: "words",
    icons: [
      "file-text",
      "files",
      "book",
      "book-open",
      "notebook",
      "newspaper",
      "sticky-note",
      "quote",
      "library",
    ],
  },
  {
    said: "money",
    icons: [
      "banknote",
      "coins",
      "credit-card",
      "wallet",
      "piggy-bank",
      "receipt",
      "landmark",
      "trending-up",
      "chart-column",
      "chart-pie",
      "calculator",
      "shopping-cart",
      "store",
      "gift",
    ],
  },
  {
    said: "going places",
    icons: [
      "plane",
      "train-front",
      "car",
      "bus",
      "bike",
      "ship",
      "rocket",
      "map",
      "map-pin",
      "compass",
      "luggage",
      "mountain",
      "globe",
      "anchor",
    ],
  },
  {
    said: "living",
    icons: [
      "house",
      "bed",
      "door-open",
      "lock",
      "shield",
      "umbrella",
      "coffee",
      "utensils",
      "wine",
      "shopping-bag",
      "glasses",
      "bath",
    ],
  },
  {
    said: "growing",
    icons: [
      "leaf",
      "tree-pine",
      "flower",
      "sprout",
      "sun",
      "moon",
      "cloud-rain",
      "waves",
      "droplet",
      "earth",
      "cat",
      "dog",
    ],
  },
  {
    said: "science and health",
    icons: [
      "atom",
      "flask-conical",
      "microscope",
      "telescope",
      "dna",
      "heart-pulse",
      "stethoscope",
      "dumbbell",
      "activity",
    ],
  },
  {
    said: "playing",
    icons: [
      "music",
      "headphones",
      "guitar",
      "play",
      "gamepad-2",
      "puzzle",
      "clapperboard",
      "party-popper",
      "trophy",
    ],
  },
  {
    said: "tools",
    icons: [
      "wrench",
      "hammer",
      "settings",
      "sliders-horizontal",
      "gauge",
      "construction",
      "factory",
      "truck",
    ],
  },
  {
    said: "marks",
    icons: [
      "star",
      "heart",
      "sparkles",
      "zap",
      "flame",
      "lightbulb",
      "circle-check",
      "circle-alert",
      "circle-help",
      "info",
      "shield-check",
      "search",
      "award",
    ],
  },
] as const;

export type Icon = (typeof GROUPS)[number]["icons"][number];

export const ICONS: readonly Icon[] = GROUPS.flatMap((group) => [...group.icons]);

const UNDER = new Map<string, string>(
  GROUPS.flatMap((group) => group.icons.map((one) => [one as string, group.said])),
);

export function isIcon(name: string): name is Icon {
  return UNDER.has(name);
}

export function iconsLike(said: string): readonly Icon[] {
  const wanted = said.trim().toLowerCase();
  if (!wanted) return ICONS;
  return ICONS.filter((name) => name.includes(wanted) || UNDER.get(name)?.includes(wanted));
}
